import React, { Fragment } from 'react';
import { Card, CardBody, Col, Container, Row, Button } from 'reactstrap';
import { ModalUnitConversion } from '../../components/unitConversions/ModalUnitConversion';
import { useUnitsConversions } from '../../hooks/unitConversions/useUnitConversions';
import { TitleDataTable } from '../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AlertDataTable } from '../../components/tableDataTable/AlertDataTable';

export const IndexUnitConversions = (props) => {

    const {
        unitsConversions, units, method,

        id_unit_from, id_unit_to, conversion_factor, handleInputChange,
        closeDialog, modal, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        handleExcelUnitConversion, loadingExcel,
        handleSearchUnitConversion, searchUnitConversion, 
        handleClearUnitConversion, 
        showDeleteAlert, modalAlert, closeDeleteAlert
    } = useUnitsConversions({ ...props });

    const headerStyle = {
            backgroundColor: "#1d5b83",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "11px",
            borderRight: "1px solid #fff",
            borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };


    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_unit_conversion)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_unit_conversion)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };
    return (
        <Fragment>
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-1">
                                <TitleDataTable
                                    titleTable="Listado de unidades de conversión"
                                    buttonActions={handleExcelUnitConversion}
                                    titleButton="Listado de unidades de conversión"
                                    isDisbled={loadingExcel}
                                    loadingIsDisabled={loadingExcel}
                                    titleCreate="Crear unidades de conversión"
                                    buttonActionsCreate={handleCreate}
                                    actionInput={handleSearchUnitConversion}
                                    valueFilter={searchUnitConversion}
                                    filterLocalStorage={true}
                                    cleanFilterLocalStorage={handleClearUnitConversion}
                                />
                                <div className="table-responsive">
                                    <DataTable
                                        value={unitsConversions}
                                        paginator
                                        rows={10}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[10, 50, 100]} 
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >
                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column 
                                            field="name_unit_from"
                                            header="Unidad origen" 
                                            body={(rowData) => (
                                                <span style={{ fontWeight: "bold" }}>
                                                    {rowData.name_unit_from}
                                                </span>
                                            )}
                                            headerStyle={headerStyle} 
                                            style={cellStyle} 
                                        />
    
                                        <Column 
                                            field="name_unit_to"
                                            header="Unidad destino"
                                            body={(rowData) => (
                                                <span style={{ fontWeight: "bold" }}>
                                                    {rowData.name_unit_to}
                                                </span>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle} />

                                        <Column 
                                            field="abbreviation_unit_from"
                                            header="Abr origen"
                                            body={(rowData) => (
                                                <span>
                                                    {rowData.abbreviation_unit_from}
                                                </span>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle} 
                                        />
                                        
                                        <Column 
                                            field="abbreviation_unit_to"
                                            header="Abr destino"
                                            body={(rowData) => (
                                                <span>
                                                    {rowData.abbreviation_unit_to}
                                                </span>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle} 
                                        />

                                        <Column 
                                            field="conversion_factor"
                                            header="Unidad de conversión"
                                            body={(rowData) => (
                                                <span>
                                                    {rowData.conversion_factor}
                                                </span>
                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle} 
                                        />
                                        
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>
                           
                            </CardBody>
                        </Card>
                    </Col>
                  
                </Row>
            </Container>
            <ModalUnitConversion
                {...{ modal, closeDialog, loading, method, units, id_unit_from, id_unit_to, conversion_factor, handleInputChange, saveCreate, saveUpdate, saveDelete }}
            />

            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar unidad de conversión"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar la unidad de conversión?"
                    alert1={true}
                    // titleAlert1={name_unit_to}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                />
            )}
        </Fragment>
    )
}
